// extracted by mini-css-extract-plugin
export default {"root":"ListAlbum_root__S5uEr","container":"ListAlbum_container__mhHP0"};